/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OffsetPaginationDto } from '../../models/offset-pagination-dto';

export interface PaymentControllerSearch$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 결제 상태
 */
  status?: Array<'\uACB0\uC81C\uB300\uAE30' | '\uC785\uAE08\uB300\uAE30' | '\uACB0\uC81C\uC644\uB8CC' | '\uCDE8\uC18C\uB300\uAE30' | '\uD658\uBD88\uC644\uB8CC' | '\uACB0\uC81C\uC2E4\uD328' | '\uACB0\uC81C\uCDE8\uC18C'>;

/**
 * 결제 수단
 */
  method?: Array<string>;

/**
 * 구분
 */
  type?: Array<'\uAD6C\uB3C5\uAD8C' | '\uC2A4\uD1A0\uC5B4' | '\uD1A0\uD070' | '\uD3EC\uC778\uD2B8' | '\uAC80\uC0AC\uB3C4\uAD6C'>;

/**
 * 센터 ID
 */
  centerId?: string;

/**
 * 사용자 ID
 */
  userId?: string;

/**
 * 시작일
 */
  startAt?: string;

/**
 * 종료일
 */
  endAt?: string;

/**
 * 회원 역할
 */
  memberRole?: 'PARENT' | 'TEACHER';
}

export function paymentControllerSearch(http: HttpClient, rootUrl: string, params: PaymentControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
  const rb = new RequestBuilder(rootUrl, paymentControllerSearch.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('status', params.status, {});
    rb.query('method', params.method, {});
    rb.query('type', params.type, {});
    rb.query('centerId', params.centerId, {});
    rb.query('userId', params.userId, {});
    rb.query('startAt', params.startAt, {});
    rb.query('endAt', params.endAt, {});
    rb.query('memberRole', params.memberRole, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OffsetPaginationDto>;
    })
  );
}

paymentControllerSearch.PATH = '/api/payment';
